// 26 Pleasant Street Massing Study
// Version 2
// October 17, 2026
//
// A zoning-envelope study of 26 Pleasant Street under the proposed Pleasant
// Street Multifamily Overlay District (PSMOD), prepared for Select Board
// review. Source files live in the Town OneDrive under
// "Development Proposals/26 Pleasant St/Massing Study" and are served from
// `frontend/public/documents/` — the page embeds them rather than transcribing
// them, because one is an interactive 3D view and the other is a drawing set.
//
// Keep `file` in step with the names in public/documents/. The axonometrics
// page loads three.js from a CDN inside its iframe; that works because
// `backend/index.js` runs helmet with `contentSecurityPolicy: false`.

export const massingStudy = {
  title: "26 Pleasant Street Massing Study",
  subtitle: "Pleasant Street Multifamily Overlay District (PSMOD)",
  version: "Version 2",
  date: "October 17, 2026",

  // The constraints this version of the study was drawn to.
  constraints: [
    "Maximum 52 parking spaces",
    "Maximum 7 floors above grade",
    "One garage entrance, on John Street",
  ],

  intro: [
    "These are envelope studies of 26 Pleasant Street under the proposed Pleasant Street Multifamily Overlay District, prepared for Select Board review. They show how much building the proposed rules would allow on the lot, and what shapes that floor area could take. They are not a design, and no development is proposed here.",
    "Both documents work from the same numbers: a 25,464 sf lot from the Town GIS parcel, a maximum floor area ratio of 4.0 giving 101,856 sf of floor area counted toward FAR, and a 17,160 sf garage for 52 cars that does not count toward FAR — 119,016 sf above grade in total. Each shows two envelopes: Envelope A, with the setbacks as the article is written, and Envelope B, with setbacks reduced to 0 ft by Special Permit, which the article allows.",
  ],

  documents: [
    {
      id: "axonometrics",
      kind: "html",
      title: "Massing designs, side by side",
      description:
        "Four axonometric models you can rotate — the lowest and widest building with and without setback relief, seven equal floors, and seven floors with a roof terrace. Drag any model and all four turn together. Figures under each model give height, floors, footprint, volume and open space against what the article requires.",
      file: "26-pleasant-street-axonometrics.html",
      frameTitle: "26 Pleasant Street axonometric massing models",
      height: 1500,
    },
    {
      id: "sheets",
      kind: "pdf",
      title: "Massing study sheets",
      description:
        "Eleven sheets: the site plan with the PSMOD setbacks and buildable footprints, then each arrangement drawn in plan, section and axonometric, with the open-space arithmetic for each.",
      file: "26-pleasant-street-massing-study-v2.pdf",
      pages: 11,
      height: 900,
    },
  ],

  // Shown under the standard sitewide sentence in the disclaimer footer.
  disclaimer:
    "This is a zoning-envelope study prepared for Select Board review, not a building design and not a development proposal. Lot geometry is taken from the Town of Brookline GIS parcel 046-20-00 (25,464 sf) and is not a survey. The placement of the garage, partial floors and plate insets is illustrative: the same floor area could be arranged differently within the same envelope.",
};

export default massingStudy;
